// Downloads a remote image to the user's disk. Ported verbatim from
// apps/core/components/checks/details/ImageViewer.tsx so the Shopify and
// WooCommerce admin surfaces behave the same way.
export async function downloadImage(url) {
  let filename;
  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Failed to fetch image: ${response.statusText}`);
    }

    const blob = await response.blob();
    const downloadUrl = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = downloadUrl;

    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    filename = pathname.substring(pathname.lastIndexOf("/") + 1);

    a.download = filename;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error(`Error downloading ${filename || url}:`, error);
  }
}

export default downloadImage;
